/**
 * GeChiUI dependencies
 */
import deprecated from '@gechiui/deprecated';

export { store } from './store';
export { default as DotTip } from './components/dot-tip';

deprecated( 'gc.nux', {
	since: '5.4',
	hint: 'gc.components.Guide can be used to show a user guide.',
} );
